import { OnInit } from '@angular/core';
import { Order } from '../../shared/models/order';
var ViewOrderComponent = /** @class */ (function () {
    function ViewOrderComponent() {
        this._order = new Order();
    }
    ViewOrderComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(ViewOrderComponent.prototype, "order", {
        get: function () {
            return this._order;
        },
        enumerable: true,
        configurable: true
    });
    return ViewOrderComponent;
}());
export { ViewOrderComponent };



// WEBPACK FOOTER //
// ./src/app/admin/view-order/view-order.component.ts.pre-build-optimizer.js